import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_FUNCTION } from "./abstract/functionAbstract";
import { getFunctionReferences, processFunctionReferences } from "./helpers/functionHelper";

const _action = `${ACTION_PREFIX_FUNCTION}_remove`;
const _header = `Remove parameter`;

export const removeFunction = (root, id) => {
  const _payload = removeFunctionLogic(root, id);

  logger.logAction(_action, _payload, ACTION_PREFIX_FUNCTION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const removeFunctionLogic = (root, id) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  
  if (!_node) {
    throw new Error("Function to remove not found");
  }
  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getFunctionReferences(root, _node);

  handleReferences(_references);

  removeNode(root, _index);

  return generatePayload(_nodeBackup, _index, _references);
};

const handleReferences = (references) => {
  const funTarget = (e) => {
    nodeUtils.removeIdReference(e.dst, nodeUtils.getID(e.src));
  };

  processFunctionReferences(references, funTarget);
};

const removeNode = (root, index) => {
  nodeUtils.modifyFunctions(root, (e) => e.splice(index, 1), false);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, uuidReferences) => {
  const _payload = {
    group: ActionGroupTypes.DELETE,
    status: nodeUtils.getName(node) ? ActionStatusTypes.SUCCESS : ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    index: index,
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

    return `Delete function '${nodeUtils.getName(node)}'.`;
}